<template>
    <div class="content">
        <div class="content-head">
            <div class="content-head-title">搜索</div>
            <el-form :inline="true" class="demo-form-inline">
                <el-form-item label="订单类型">
                    <el-select v-model="params.Orders_DiscountCate" placeholder="请选择" class="el-select-medium">
                        <el-option value="">全部订单</el-option>
                        <el-option v-for="item in Orders_DiscountCateOpt" :key="item.ID" :label="item.Name" :value="item.ID"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="付款方式">
                    <el-select v-model="params.paytype" placeholder="请选择" class="el-select-medium">
                        <el-option value="">全部订单</el-option>
                        <el-option v-for="item in paytypeOpt" :key="item.Pay_Type_ID" :label="item.Pay_Type_Name" :value="item.Pay_Type_ID"></el-option>
                    </el-select>
                </el-form-item>

                <el-form-item label="是否显示">
                    <el-select v-model="params.GatheringDefault" placeholder="请选择" class="el-select-mini">
                        <el-option v-for="item in GatheringDefaultOpt" :key="item.value" :label="item.label" :value="item.value"></el-option>
                    </el-select>
                </el-form-item>

                <el-form-item label="分支机构" v-if="isFiltration">
                    <el-input v-model="params.officename" placeholder="" clearable class="el-select-medium"></el-input>
                </el-form-item>
                <el-form-item label="业务员" v-if="isFiltration">
                    <el-input v-model="params.slaemanename" placeholder="" clearable class="el-select-medium"></el-input>
                </el-form-item>
                <el-form-item label="客户名称">
                    <el-input v-model="params.customername" placeholder="" clearable class="el-select-medium"></el-input>
                </el-form-item>
                <el-form-item label="工程名称" v-if="isFiltration">
                    <el-input v-model="params.projectname" placeholder="" clearable class="el-select-medium"></el-input>
                </el-form-item>
                <el-form-item label="ERP订单号" v-if="isFiltration">
                    <el-input v-model="params.erporderssn" placeholder="" clearable class="el-select-medium"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="getGSTOrdersDistributeList(true)" icon="el-icon-search" :loading="loadingBtn">搜索</el-button>
                </el-form-item>
                <el-form-item>
                    <el-button @click="onRefresh" icon="el-icon-refresh" :loading="loadingBtn">重置</el-button>
                </el-form-item>
                <el-form-item>
                    <el-button @click="setFiltration" :icon="!isFiltration ? 'el-icon-arrow-down' : 'el-icon-arrow-up'">
                        {{ !isFiltration ? '展开' : '收起' }}
                    </el-button>
                </el-form-item>
            </el-form>
        </div>
        <div class="content-table">
            <div class="content-table-title">
                <span>订单列表</span>
                <span>
                    <el-button @click="getGSTOrdersSummary_Export2()">不再显示此单</el-button>
                    <el-dropdown trigger="click" style="margin-left: 10px; margin-right: 10px">
                        <el-button type="primary">
                            导出
                            <i class="el-icon-arrow-down el-icon--right"></i>
                        </el-button>
                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item>
                                <span @click="getGSTOrdersSummary_Export2()">导出结果订单</span>
                            </el-dropdown-item>
                            <el-dropdown-item>
                                <span @click="getGSTOrdersSummary_Export2()">导出勾选订单</span>
                            </el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                </span>
            </div>
            <el-table :data="tableData" ref="table" border @selection-change="handleSelectionChange" :height="maxheight" style="width: 100%" :header-cell-style="{ backgroundColor: '#F5F7FA' }" v-loading="loadingBtn">
                <el-table-column type="selection" width="55" align="center"></el-table-column>
                <el-table-column prop="Orders_SN" label="订单号" align="center" width="120"></el-table-column>
                <el-table-column prop="ORDER_NO" label="ERP订单号" align="center" width="120"></el-table-column>
                <el-table-column prop="Orders_CustomerName" label="客户名称" show-overflow-tooltip align="center"></el-table-column>
                <el-table-column prop="Orders_ProjectName" label="工程名称" show-overflow-tooltip align="center"></el-table-column>
                <el-table-column prop="RETURN_AMOUNT" label="合同金额" align="center" width="120">
                    <template slot-scope="scope">￥ {{ scope.row.ORDER_AMOUNT }}</template>
                </el-table-column>
                <el-table-column prop="ORDER_AMOUNT" label="发货金额" align="center" width="120">
                    <template slot-scope="scope">￥ {{ scope.row.apply_totalamount }}</template>
                </el-table-column>
                <el-table-column prop="PICKED_AMOUNT" label="已申报金额" align="center" width="120">
                    <template slot-scope="scope">￥ {{ scope.row.PICKED_AMOUNT }}</template>
                </el-table-column>
                <el-table-column prop="PAYMENT_AMOUNT" label="ERP回款额" align="center" width="120">
                    <template slot-scope="scope">￥ {{ scope.row.PAYMENT_AMOUNT }}</template>
                </el-table-column>
                <el-table-column prop="PICKED_ARREARAGE" label="付款方式" align="center" width="120" show-overflow-tooltip>
                    <template slot-scope="scope">{{ scope.row.Orders_Payway_Name }}</template>
                </el-table-column>
                <el-table-column prop="PICKED_ARREARAGE" label="订单审批日期" align="center" width="120">
                    <template slot-scope="scope">{{ scope.row.Orders_AuditTime | formatDate }}</template>
                </el-table-column>
                <el-table-column prop="office_name" label="分支机构" align="center" width="120"></el-table-column>
                <el-table-column prop="sale_name" label="业务员" align="center" width="120"></el-table-column>
                <el-table-column label="操作" align="center" width="120" fixed="right">
                    <template slot-scope="{}">
                        <div class="operation-bar">
                            <span class="operation-bar-block" @click="getGSTOrdersSummary_Export2()">创建申报</span>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
            <div>
                <Pagination :paginationOptions="paginationOptions" @size-change="handleSizeChange" @current-change="handleCurrentChange" />
            </div>
        </div>
    </div>
</template>
<script>
import Pagination from '@/components/Pagination.vue';
import { myMixin } from '@/utils/mixin.js';
import { cloneDeep } from 'lodash';
import { downloadFile, toLowerCaseKeys } from '@/utils/utils.js';
export default {
    name: 'waitfordeclarationOrder',
    mixins: [myMixin],
    components: {
        Pagination
    },
    data() {
        return {
            loadingBtn: false,
            params: {},
            Orders_DiscountCateOpt: [],
            paytypeOpt: [],
            tableData: [],
            GatheringDefaultOpt: [
                { label: '显示', value: 0 },
                { label: '不显示', value: 1 }
            ]
        };
    },
    mounted() {
        this.onRefresh();
        this.getDiscountCategorys();
        this.getOrdersPayTypes();
    },
    methods: {
        /*
    重置查询
    */
        onRefresh() {
            (this.params = {
                officename: '',
                projectname: '',
                customername: '',
                slaemanename: '',
                Orders_DiscountCate: '',
                erporderssn: '',
                paytype: '',
                GatheringDefault: 0
            }),
                this.getGSTOrdersDistributeList(true);
        },

        /*
    列表查询
    */
        getGSTOrdersDistributeList(flag = false) {
            this.loadingBtn = true;
            if (flag) {
                this.paginationOptions = {
                    Page: 1,
                    total: 0,
                    PageSize: 40
                };
            }
            this.$newsApi
                .getGSTOrdersDistributeList(this.filteropt())
                .then((res) => {
                    if (res.data.Resultcode == 0) {
                        this.tableData = res.data.data;
                        this.paginationOptions.total = res.data.RecordCount;
                    } else {
                        this.tableData = [];
                        this.paginationOptions.total = 0;
                    }
                })
                .finally(() => (this.loadingBtn = false));
        },
        filteropt() {
            let params = cloneDeep(this.params);
            const obj = this.Orders_DiscountCateOpt.find((item) => item.ID == this.params.Orders_DiscountCate);
            params.Orders_DiscountCate = obj ? obj.Code : '';
            return { json: JSON.stringify(toLowerCaseKeys(params)), Page: this.paginationOptions.Page, PageSize: this.paginationOptions.PageSize };
        },
        /*
   导出结果
   */
        getGSTOrdersSummary_Export2() {
            alert('接口待开发');
            // this.$newsApi.getGSTOrdersSummary_Export2(this.filteropt()).then(res => {
            //   if (res.data.Resultcode == 0) {
            //     downloadFile(res.data.data, res.data.Resultinfo)
            //   }
            // })
        },
        getDiscountCategorys() {
            this.$newsApi.getDiscountCategorys().then((res) => {
                if (res.data.Resultcode == 0) {
                    this.Orders_DiscountCateOpt = res.data.data;
                }
            });
        },
        getOrdersPayTypes() {
            this.$newsApi.common.getOrdersPayTypes().then((res) => {
                if (res.data.Resultcode == 0) {
                    this.paytypeOpt = res.data.data;
                }
            });
        },
        handleSelectionChange(val) {
            console.log(val, '===========');
            // this.multipleSelection = val
        },
        handleSizeChange(newSize) {
            this.paginationOptions.PageSize = newSize;
            this.getGSTOrdersDistributeList();
        },
        handleCurrentChange(newPage) {
            this.paginationOptions.Page = newPage;
            this.getGSTOrdersDistributeList();
        }
    }
};
</script>
